import { Link } from 'react-router-dom';
import { categories } from '@/mocks/gossip';

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-4 py-14 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-line text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">爆瓜福利</span>
          </div>
          <p className="mt-4 text-sm leading-6 text-foreground-600">
            聚焦娱乐吃瓜的资讯与分享社区，聚合最新爆料、明星动态与影视综艺热议，并提供分享帖、分享群、分享链接与分享码资源合集。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600">
              <i className="ri-wechat-line"></i>
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600">
              <i className="ri-qq-line"></i>
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600">
              <i className="ri-mail-line"></i>
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-foreground-950">内容方向</h4>
          <ul className="mt-4 space-y-3">
            {categories.slice(0, 5).map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/gossip?category=${c.slug}`}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-foreground-950">快速导航</h4>
          <ul className="mt-4 space-y-3">
            <li>
              <Link to="/gossip" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                吃瓜广场
              </Link>
            </li>
            <li>
              <Link to="/community" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                分享社区
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                常见问题
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                关于我们
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-foreground-950">联系我们</h4>
          <ul className="mt-4 space-y-3 text-sm text-foreground-600">
            <li className="flex items-start gap-2">
              <i className="ri-mail-line mt-0.5 text-primary-600"></i>
              <span>hello@baoguafuli.example</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-time-line mt-0.5 text-primary-600"></i>
              <span>内容更新：周一至周日 全天</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-shield-check-line mt-0.5 text-primary-600"></i>
              <span>内容原则：真实、克制、可查证</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 爆瓜福利 · 娱乐吃瓜资讯与分享社区</p>
          <p>本站内容仅用于资讯分享，请理性讨论，尊重当事人。</p>
        </div>
      </div>
    </footer>
  );
}